import { render, staticRenderFns } from "./password-modal.vue?vue&type=template&id=59060d92&"
import script from "./password-modal.vue?vue&type=script&lang=js&"
export * from "./password-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports